import serverTimeReducer from './';

export default serverTimeReducer;
